<h2 class="sr-only">{{ "Standardsuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="standard" #form="ngForm">
  @if (standard) {
    <div>
      <cap-geometergeschaeft-nummer
        (ngModelChange)="standard && (standard.geometerGeschaeft = $event)"
        [hasfocus]="true"
        [ngModel]="standard && standard.geometerGeschaeft"
        [nurGueltige]="false"
        [searchMode]="polGemeindeSearchMode"
        heading="GeometergeschaeftNummer"
        name="geometerGeschaeft"></cap-geometergeschaeft-nummer>
      <cap-form-row>
        <cap-form-control column-classes="col-md-2,col-md-4" labelKey="Geschäftstyp">
          <select
            (ngModelChange)="standard && (standard.geschaeftsTyp = $event) && initVerarbeitungsArtChoice()"
            [ngModel]="standard && standard.geschaeftsTyp"
            name="geschaeftsstatus">
            <option [ngValue]=""></option>
            @for (typ of standard.geschaeftsTypList; track typ) {
              <option [ngValue]="typ">{{ typ | translate }}</option>
            }
          </select>
        </cap-form-control>
      </cap-form-row>
      @if (!(standard.mVerarbeitungsArt?.access === "DEACTIVATED")) {
        <div>
          <cap-form-row>
            <cap-form-control column-classes="col-md-2,col-md-4" labelKey="Verarbeitungsart">
              <select
                (ngModelChange)="standard && (standard.verarbeitungsArt = $event)"
                [ngModel]="standard && standard.verarbeitungsArt"
                name="verarbeitungsart">
                <option [ngValue]=""></option>
                @for (art of verarbeitungsArtChoice; track art) {
                  <option [ngValue]="art">{{ art | translate }}</option>
                }
              </select>
            </cap-form-control>
          </cap-form-row>
        </div>
      }
      @if (!(standard.mBeschreibung?.access === "NONE")) {
        <div>
          <cap-form-row>
            <cap-form-control column-classes="col-md-2,col-md-4" labelKey="Beschreibung">
              <input
                (ngModelChange)="standard && (standard.beschreibung = $event)"
                [ngModel]="standard && standard.beschreibung"
                id="beschreibung"
                name="beschreibung"
                type="text" />
            </cap-form-control>
          </cap-form-row>
        </div>
      }
      <div class="row my-2">
        @if (!(standard.mAvMutationsNummer?.access === "DEACTIVATED")) {
          <div class="col-md-6">
            <cap-av-mutations-nummer
              (ngModelChange)="standard && (standard.avMutationsNummer = $event)"
              [ngModel]="standard && standard.avMutationsNummer"
              class="mt-3 mb-0"
              heading="avMutationsNummer"
              name="avMutation"></cap-av-mutations-nummer>
          </div>
        }
      </div>
      <div class="row my-2">
        <div class="col-3">
          <cap-tagebuchstatus-selection
            (ngModelChange)="standard && (standard.status = $event)"
            [ngModel]="standard && standard.status"
            name="bearbeitetstatusSelection"></cap-tagebuchstatus-selection>
        </div>
      </div>
      <div class="p-2" id="actionpane">
        <div class="rechtsbuendig">
          <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
          <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
        </div>
      </div>
    </div>
  }
</form>
